import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import MoveNotice from "@/pages/MoveNotice";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";

// Avoid a self-redirect if this app is also served on the destination domain.
const isNewSite = ["fcyit.com", "www.fcyit.com"].includes(window.location.hostname.toLowerCase());

function App() {
  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isNewSite ? <HomePage /> : <MoveNotice />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/inbox" element={<AdminInbox />} />
          <Route path="*" element={isNewSite ? <HomePage /> : <MoveNotice />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
